/**
 * 受講生の学習遅延・不振の警告モーダル制御
 * ログイン後の最初の画面（コース一覧）で表示され、「確認しました」で既読を記録して閉じる。
 */
const initStudentWarningModal = () => {
    const modal = document.getElementById('student-warning-modal');
    if (!modal) {
        return;
    }

    const closeButton = document.getElementById('student-warning-modal-close');
    const readUrl = modal.dataset.readUrl;
    const warningType = modal.dataset.warningType;
    const triggerCardId = modal.dataset.triggerCardId;
    const csrfToken = modal.dataset.csrf;

    const close = () => {
        modal.classList.add('hidden');

        fetch(readUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify({
                warning_type: warningType,
                trigger_card_id: triggerCardId || null,
            }),
        }).catch(() => {
            // 既読記録に失敗しても表示は閉じたままにする（次回ログイン時に再表示される）
        });
    };

    closeButton?.addEventListener('click', close);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStudentWarningModal);
} else {
    initStudentWarningModal();
}
